import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useParams } from 'react-router-dom';

import { useKimLhc } from '@/context/KimLhc';
import { useGetVideoInfo } from './hooks/useVideoInfo';
import { useApplicationContext } from '@/context/v1/Application/context';
import { VideoSection } from '@/components/views/Report/KimLhc/Components/Shared';
import {
	OrganizationFormItem,
	CompanyFormItem,
	SectorFormItem,
	LineFormItem,
	WorkstationFormItem,
	ActivityFormItem,
	EvaluatorFormItem,
	CollectDateFormItem,
	WorkdayDurationFormItem,
	ActivityDurationFormItem
} from '@/components/views/Report/KimLhc/Components/Form/Fields';
import { PageTitle } from '@/components/views/Report/KimLhc/Components/Shared/styles';
import { FieldNamesEnum } from '@/components/views/Report/KimLhc/types';

export function GeneralInformation(): JSX.Element {
	const { videoUrl } = useKimLhc();
	const { file_id } = useParams<{ file_id: string }>();
	const { organization, company } = useApplicationContext();

	const { data: videoInfo } = useGetVideoInfo({
		organization_id: organization?.id,
		company_id: company?.id,
		file_id: file_id
	});

	const GENERAL_INFO_GROUP = FieldNamesEnum.GENERAL_INFORMATION;

	return (
		<Row gutter={[0, 32]}>
			<Col span={24}>
				<PageTitle level={4}>{I18n.get('General information')}</PageTitle>
			</Col>
			<Col span={24}>
				<VideoSection videoInfo={videoInfo} videoUrl={videoUrl} />
			</Col>
			<Col span={24}>
				<Row gutter={[32, 8]}>
					<Col xs={12} xl={8}>
						<OrganizationFormItem fieldName={[GENERAL_INFO_GROUP, 'organization_id']} disabled />
					</Col>
					<Col xs={12} xl={8}>
						<CompanyFormItem fieldName={[GENERAL_INFO_GROUP, 'company_id']} disabled />
					</Col>
					<Col xs={12} xl={8}>
						<SectorFormItem fieldName={[GENERAL_INFO_GROUP, 'sector_id']} />
					</Col>
					<Col xs={12} xl={8}>
						<LineFormItem fieldName={[GENERAL_INFO_GROUP, 'line_id']} />
					</Col>
					<Col xs={12} xl={8}>
						<WorkstationFormItem fieldName={[GENERAL_INFO_GROUP, 'workstation_id']} />
					</Col>
					<Col xs={12} xl={8}>
						<ActivityFormItem fieldName={[GENERAL_INFO_GROUP, 'activity_id']} />
					</Col>
					<Col xs={12} xl={8}>
						<EvaluatorFormItem fieldName={[GENERAL_INFO_GROUP, 'evaluator_id']} />
					</Col>
					<Col xs={12} xl={8}>
						<CollectDateFormItem fieldName={[GENERAL_INFO_GROUP, 'collect_date']} />
					</Col>
					<Col xs={12} xl={8}>
						<WorkdayDurationFormItem fieldName={[GENERAL_INFO_GROUP, 'workday_duration']} />
					</Col>
					<Col xs={12} xl={8}>
						<ActivityDurationFormItem fieldName={[GENERAL_INFO_GROUP, 'activity_duration']} />
					</Col>
				</Row>
			</Col>
		</Row>
	);
}
